import { pick as _pick } from "lodash";

/**
 * lodash omit + proper typings
 */
export function pick<T extends Record<string, any>, K extends keyof T>(
  obj: T,
  ...keys: K[]
) {
  return _pick(obj, ...keys) as Pick<T, K>;
}
